import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/covered-and-cancelled-lessons')()
